// KnowledgeQuality-local constants: sizing, page sizes, labels, table meta.

export const KQ_DRAWER_WIDTH_CLS = "w-[1400px] max-w-[95vw]";

export const KQ_TABLE_PAGE_SIZE = 5;

export const KQ_TABLE_MAX_HEIGHT = {
  findings: "360px",
  entities: "380px",
  evidence: "380px",
} as const;

export const KQ_COMPLETENESS_TARGET = 0.95;

export const KQ_HEADER_COPY = {
  title: "Knowledge Quality",
  description:
    "Completeness, richness, redundancy, and evidence quality assessed for each knowledge entity extracted from this document.",
  bodyDescription:
    "Completeness, richness, redundancy, and evidence trust assessed per extracted knowledge entity. Not a compliance score.",
  overallLabel: "Overall knowledge quality",
  validatedLabel: "Validated",
  loading: "Loading knowledge quality...",
} as const;

export const KQ_SUMMARY_LABELS = {
  section: "Knowledge quality summary",
  sectionRight: "Aggregated across entities",
  entitiesDetected: "Knowledge entities detected",
  averageCompleteness: "Average completeness",
  averageRichness: "Average knowledge richness",
  averageTrust: "Average evidence trust",
  findingsRaised: "Findings raised",
  primary: "Primary quality highlight",
  primaryRight: "Strongest supported entity",
  findings: "Knowledge quality findings",
  findingsRightSuffix: "findings · gaps first",
  entities: "Entity coverage",
  entitiesRightSuffix: "entities · completeness · richness · trust",
  evidence: "Evidence & trust",
  evidenceRightSuffix: "evidence records",
} as const;

export const KQ_PRIMARY_LABELS = {
  qualityTag: "High Quality",
  aiTag: "AI",
  aiSection: "Quality assessment",
  overallCompleteness: "Overall completeness",
  richness: "Richness",
  evidenceRecords: "Evidence records",
  duplicateEntities: "Duplicate entities",
  qualityIndex: "Quality index",
  trust: "Trust",
  ringCaption: "Overall",
} as const;

export const KQ_BANNER = {
  missingAttrsFallback:
    "Some entities do not carry every required attribute.",
  missingAttrsHelp:
    "Add the missing information to raise completeness above 95%.",
} as const;

export const KQ_FINDING_COL = {
  finding: { header: "Finding", minWidth: 160 },
  entity: { header: "Entity", minWidth: 180 },
  description: { header: "Description" },
  severity: { header: "Severity", width: "100px" },
  source: { header: "Source", width: "140px" },
} as const;

export const KQ_ENTITY_COL = {
  entity: { header: "Knowledge entity", minWidth: 200 },
  attrs: { header: "Attributes", width: "110px" },
  completeness: { header: "Completeness", minWidth: 140 },
  richness: { header: "Richness", minWidth: 140 },
  trust: { header: "Trust", minWidth: 130 },
  source: { header: "Source", width: "150px" },
} as const;

export const KQ_EVIDENCE_COL = {
  entity: { header: "Entity", minWidth: 180 },
  type: { header: "Type", width: "100px" },
  source: { header: "Source", minWidth: 150 },
  strength: { header: "Strength", width: "100px" },
  reliability: { header: "Reliability", width: "110px" },
  recency: { header: "Recency", width: "100px" },
  consistency: { header: "Consistency", width: "120px" },
  trust: { header: "Trust", minWidth: 130 },
} as const;

export const KQ_RELATED_CONCEPTS_MAX = 4;
